'use client'
import { useState } from "react";

const { PrismicLink, PrismicImage, PrismicRichText } = require("@prismicio/react")

/**
 * @typedef {import("@prismicio/client").Content.NewsLetterSlice} NewsLetterSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<NewsLetterSlice>} NewsLetterProps
 * @param {NewsLetterProps}
 */
const NewsLetter = ({ slice, index }) => {
  const [hasSubmited, setHasSubmited] = useState(false)
  function submit(e) {
    e.preventDefault();
    setHasSubmited(!hasSubmited);
    setTimeout(() => set(), 3000);
  }

  function set() {
    setHasSubmited(false);
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white bg-grain flex flex-col overflow-hidden pb-11 md:pb-20 lg:pb-[100px] border-t-2 border-dark-grey relative z-[20]">
      <div className="pt-30px md:pt-20 text-dark-grey px-4 md:px-7 lg:px-36 max-w-[1400px] m-auto">
        <div className="mb-30px max-w-[600px]">
          <h2 className="subtitle mb-2.5">{slice.primary.seo_title}</h2>
        </div>
        <div className="text-newsletter md:flex">
          <div className="mb-14 lg:w-1/2">
            <div className="md:w-[300px] lg:w-[375px] md:pr-10">
              {
                slice.primary.some.map((item, i) => {
                  return <PrismicLink key={i} field={item.cta_url} className="flex items-center border-b-2 border-dark-grey social_btn">
                    <div className={`w-[70px] h-[70px]  border-x-2 border-dark-grey flex items-center justify-center
                            ${i == 0 ? 'border-t-2' : ''}`}>
                      <PrismicImage field={item.picto} className="w-[32px] h-[32px]"  loading={index === 0 ? '' : 'lazy'}/>
                    </div>
                    <span className="ml-30px">{item.cta_url?.text}</span>
                  </PrismicLink>
                })
              }
            </div>
          </div>
          <div className="lg:w-1/2">
            <div>
              <div className="mb-4">
                <PrismicRichText
                  field={slice.primary.title}
                  components={{
                    heading2: ({ children }) => <h2 className="h3">{children}</h2>,
                    heading3: ({ children }) => <h3>{children}</h3>,
                  }} />
              </div>
              <div className="text-highlight mb-30px">
                <PrismicRichText field={slice.primary.text} />
              </div>
              <form className="text-dark-grey" name="newsletter" method="post" onSubmit={submit}>
                <div className="relative overflow-hidden rounded-full border-dark-grey bg-white border-2 mb-2.5">
                  <div className="pl-30px pr-1.5 py-1.5 flex">
                    <input className="w-full mr-4 input-newsletter" type="text"
                      placeholder="Votre email" name="mail" required />
                    <input
                      className="cursor-pointer bg-pink submit-newsletter border-2 rounded-30px border-dark-grey button-text-newsletter"
                      type="submit" value="Je m'abonne" />
                  </div>
                  <div className={`absolute w-full bg-white h-full flex justify-center items-center top-0 transition-all duration-300  ${hasSubmited ? 'translate-y-0' : 'translate-y-20'} rounder-full`}>
                    <p className="text-newsletter">{slice.primary.post_subscription_text}</p>
                  </div>
                </div>
                <div className="mentions-newsletter">
                  <PrismicRichText field={slice.primary.post_field_text} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsLetter;
